import { useEffect, useState } from 'react';

// The API can be asleep (free hosting plans pause it when idle). Opening the sign-in page pings it so it
// starts waking while the person types, and a slow sign-in explains the wait instead of a silent spinner.
const API_URL = import.meta.env.VITE_API_URL || import.meta.env.VITE_API_BASE_URL || '/api';
const HEALTH_URL = `${String(API_URL).replace(/\/+$/, '').replace(/\/api$/, '')}/api/health`;

export default function ServerWakeNotice({ active }) {
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    fetch(HEALTH_URL, { cache: 'no-store' }).catch(() => {});
  }, []);

  useEffect(() => {
    if (!active) {
      setSlow(false);
      return undefined;
    }
    const timer = setTimeout(() => setSlow(true), 4000);
    return () => clearTimeout(timer);
  }, [active]);

  if (!slow) return null;
  return (
    <p role="status" className="mt-3 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800">
      Waking up the server. The first sign-in after a quiet spell can take up to a minute.
    </p>
  );
}
